import { getFirstLetterUppercase, formatPhone } from 'Utils/helpers';
import {
  SET_CREW,
  SET_SELECTED_CREW,
  CREW_DELETED,
  FETCHING_CREW,
  CLEAR_CREW,
  CREW_CREATED,
  CREW_UPDATED,
  nonAppCrewActionTypes,
} from './actions';

const initialState = {
  crewInitials: [],
  totalCrew: 0,
  selectedCrew: null,
  crewCreated: false,
  crewUpdated: false,
  crewDeleted: '',
  fetchingCrew: true,
};

export const nonAppCrewReducer = (state = initialState, action: nonAppCrewActionTypes) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CREW: {
      const { data: crew, meta: { total: totalCrew } } = payload;
      let crewInitials = [];

      if (crew.length > 0) {
        crewInitials = Object.values(
          crew.reduce((items, member) => {
            const {
              id,
              first_name: firstName,
              last_name: lastName,
              contact_email: email,
              labor_rate: laborRate,
              phones,
            } = member;

            // The API returns first_name/last_name (no full_name field) and a
            // phones[] array (not a single phone) — derive both here.
            const fullName = [firstName, lastName].filter(Boolean).join(' ');
            const phone = Array.isArray(phones) ? phones.find((p: any) => p.is_primary) || phones[0] : phones;

            const initial = getFirstLetterUppercase(firstName);
            if (!items[initial]) {
              items[initial] = { initial, crew: [] };
            }

            let primaryPhone = '';
            let primaryPhoneExtension = '';

            if (phone?.value) {
              primaryPhone = formatPhone(phone.value);
              primaryPhoneExtension = phone.extension || '';
            }

            items[initial].crew.push({
              id,
              firstName,
              lastName,
              fullName,
              email,
              laborRate,
              phone,
              primaryPhone,
              primaryPhoneExtension,
            });

            return items;
          }, {})
        );
      }

      return { ...state, crewInitials, totalCrew, fetchingCrew: false };
    }

    case SET_SELECTED_CREW:
      return { ...state, selectedCrew: payload };

    case FETCHING_CREW:
      return { ...state, fetchingCrew: payload };

    case CREW_DELETED:
      return { ...state, crewDeleted: payload };

    case CREW_CREATED:
      return { ...state, crewCreated: payload };

    case CREW_UPDATED:
      return { ...state, crewUpdated: payload };

    case CLEAR_CREW:
      return initialState;

    default:
      return state;
  }
};
